import React from "react";
import WelcomeFormPage from "./WelcomeFormPage";

/**
 * /clinics/:clinicId/comm-pref/:patientId
 * Same communication-preferences experience as the welcome page
 * (form, confirmation, and clinic-website redirect).
 */
const CommPrefs = () => <WelcomeFormPage />;

export default CommPrefs;
